import { createLogic, StandardAction } from "redux-logic";
import {
  SET_BOX_REVIEW_MODEL,
  SET_CURRENT_BOX,
  setURLs,
  setImageData,
  setStock,
  setCurrentBox,
  clearURLsAndData,
  setOrderShippingMethod,
  setWrongLabelModalStatus,
  setForceAction,
  setErrorData,
  setCurrentOrderLookupValue,
  SWITCH_TO_DELIVERY,
  setBoxReviewModel,
  setBoxReviewAction,
  switchToDelivery,
  setShippingMethods,
  LOAD_BOX_REVIEW_ORDER,
  LOAD_IPACK_IMAGES,
  LOAD_SHIPPING_METHODS,
  loadShippingMethods,
  loadIPackImages,
  SET_BOX_REVIEW_ACTION,
  loadBoxReviewOrder,
  reloadBoxReview
}
  from "../reducers/boxReviewReducer";
import {
  setLoadingStatus
} from "../reducers/applicationStateReducer";
import ReviewEndpoints from "../../review/ReviewEndpoints";
import { LimaCompanyID, LimaShopID, API_PATH } from "../../../utils/Constants";
import { PayloadWrapper } from "../types/PayloadWrapper";
import BoxReviewConstants from "../../boxReview/Constants";
import { error } from "console";

const { ActionStates } = BoxReviewConstants;

const setBoxReviewActionLogic = createLogic({
  type: SET_BOX_REVIEW_ACTION,
  process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, { value: number }>;
    },
    dispatch,
    done
  ) {
    const { boxWasUpdated, currentOrderLookupValue } = getState().boxReviewReducer;
    if (action.payload.value === ActionStates.LOAD_BOX && boxWasUpdated) {
      dispatch(loadBoxReviewOrder({ inputValue: currentOrderLookupValue, switchToDelivery: false }));
    }
    done();
  },
});

const boxCallbackLogic = createLogic({
  type: SET_CURRENT_BOX,
  process(
    {
      action,
    }: {
      action: StandardAction<string, { callback: () => void | undefined }>;
    },
  ) {
    if (typeof action.payload.callback === "function") {
      action.payload.callback();
    }
  },
});

const sortBoxCallbackLogic = createLogic({
  type: SET_BOX_REVIEW_MODEL,
  process(
    {
      action,
    }: {
      action: StandardAction<string, { callback: () => void | undefined }>;
    },
  ) {
    if (typeof action.payload.callback === "function") {
      action.payload.callback();
    }
  },
});

const fetchIPackImagesLogic = createLogic({
  type: LOAD_IPACK_IMAGES,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { currentBox } = getState().boxReviewReducer;
    await ReviewEndpoints.loadContentImage(currentBox.boxBarcode)
      .then((result) => {
        if (currentBox.boxBarcode === getState().boxReviewReducer?.currentBox?.boxBarcode) {
          dispatch(setImageData({ imageBytes: result.imageBytes, imageFound: result.imageFound }))
        }
      }).catch((error) => {
        console.log(error);
        dispatch(setImageData({ imageBytes: [], imageFound:false}));
      });
    done();
  },
});

const fetchShippingMethodsLogic = createLogic({
  type: LOAD_SHIPPING_METHODS,
  async process(
    {
      getState,
    }: {
      getState: any;
    },
    dispatch,
    done
  ) {
    const { currentBox } = getState().boxReviewReducer;
    const { operatorID, workstationID } = getState().loginInfoReducer;
    await ReviewEndpoints.getShippingMethods(
      operatorID,
      workstationID,
      currentBox.orderShippingMethod,
      currentBox.orderShopID,
      currentBox.orderNumber
    ).then((res) => {
      if (currentBox.boxBarcode === getState().boxReviewReducer?.currentBox?.boxBarcode) {
        let shippingMethodsForDropdown = res.map((r: { id: any; backOfficeName: any; }) => {
          return { key: r.id, value: r.id, text: r.backOfficeName };
        });
        dispatch(setShippingMethods(shippingMethodsForDropdown));
      }
    });
    done();
  },
});

const switchToDeliveryLogic = createLogic({
  type: SWITCH_TO_DELIVERY,
  process({
    getState,
    action
  }: {
    getState: any,
    action: StandardAction<string, { value: boolean }>;
  },
    dispatch,
    done
  ) {
    const { currentBox } = getState().boxReviewReducer;
    const { operatorID, workstationID } = getState().loginInfoReducer;
    let endpoint: ((operatorId: number, workstationId: number, invoiceNumber: number) => Promise<any>)
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    if (action.payload.value) {
      endpoint = ReviewEndpoints.restartDelivery
      dispatch(reloadBoxReview(new PayloadWrapper(true)));
    } else {
      endpoint = ReviewEndpoints.continueDelivery
    }
    endpoint(operatorID, workstationID, currentBox.invoice.invoiceNumber)
      .then((result) => {
        dispatch(setBoxReviewModel({
          sortBox: result,
          callback: () => dispatch(setBoxReviewAction(new PayloadWrapper(ActionStates.COMPLETE_BOX)))
        }))
      })
      .catch((err) => {
        dispatch(setErrorData({
          showInfoModal: true,
          infoMessage: err.message,
          currentError: ""
        })
        );
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        done();
      });
  }
})

const loadBoxReviewDataLogic = createLogic({
  type: LOAD_BOX_REVIEW_ORDER,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<string, { inputValue: string, switchToDelivery: boolean }>;
    },
    dispatch,
    done
  ) {
    const { operatorID, workstationID } = getState().loginInfoReducer;
    dispatch(clearURLsAndData())
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    await ReviewEndpoints.loadOrderForReview(action.payload.inputValue, operatorID, workstationID)
      .then((result) => {
        console.log(result)
        const ipackBoxId = result.iPackBox?.id;
        if (ipackBoxId != null) {
          const rxShippingItems = result.shippings.filter((x: { iPackBoxID: any; }) => x.iPackBoxID == ipackBoxId)[0]?.items;
          let rxItems = result.invoice.items.filter((x: { isRX: any; skuId: any; }) => x.isRX && rxShippingItems.some((z: { skuID: any; }) => z.skuID == x.skuId));
          result.toCheckCount = rxItems.length;
        }
        result.checkedCount = 0;
        const resultImageUrl =
          !!result.boxBarcode &&
          API_PATH + "/api/review/image?boxBarcode=" + result.boxBarcode;
        const resultLabelUrl =
          !!result.boxBarcode &&
          API_PATH + "/api/review/label?boxBarcode=" + result.boxBarcode;
        

        const isWorkstationApoteaAndNotShopIDTwoOrSix =
          result.companyID === LimaCompanyID.ApoteaAB &&
          result.orderShopID !== LimaShopID.Vitaminvaruhuset &&
          result.orderShopID !== LimaShopID.Apotea;

        if (isWorkstationApoteaAndNotShopIDTwoOrSix) {
          const errorModal = {
            showInfoModal: true,
            infoMessage: "OBS: Packa om i vitt emballage, ej Apotea-order",
            currentError: ""
          }
          dispatch(setErrorData({ ...errorModal }))
        }
        dispatch(setCurrentOrderLookupValue(new PayloadWrapper(action.payload.inputValue)))
        dispatch(setOrderShippingMethod(new PayloadWrapper(result.orderShippingMethod)));
        dispatch(setCurrentBox({ box: result, callback: null }));
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        dispatch(setURLs({ imageURL: resultImageUrl, labelURL: resultLabelUrl }))

        if (result.iPackBox && !result.previouslyControlled) {
          const wrongLabelModalOpen: boolean = result.iPackBox.validationResult === 3;
          const forceAction: boolean = result.iPackBox.validationResult === 2;
          dispatch(setForceAction(new PayloadWrapper(forceAction)));
          dispatch(setWrongLabelModalStatus(new PayloadWrapper(wrongLabelModalOpen)));
        }

        if (action.payload.switchToDelivery) {
          if (!result.containsDeliveredItems) {
            dispatch(switchToDelivery(new PayloadWrapper(true)))
          } else if (result.partialDeliveryNotFinished) {
            dispatch(switchToDelivery(new PayloadWrapper(false)))
          }
        }
      })
      .then(() => {
        const { currentBox } = getState().boxReviewReducer;
        if (currentBox.shippings.length > 0) {
          dispatch(loadShippingMethods());
        }
        if (currentBox.boxBarcode != null) {
          dispatch(loadIPackImages());
        }
      })
      .catch((error) => {
        dispatch(setErrorData({
          showInfoModal: true,
          infoMessage: error.message,
          currentError: error.message
        })
        );
      })
      .finally(() => {
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
      });
    done();
  }
})

export {
  boxCallbackLogic,
  sortBoxCallbackLogic,
  switchToDeliveryLogic,
  loadBoxReviewDataLogic,
  fetchShippingMethodsLogic,
  fetchIPackImagesLogic,
  setBoxReviewActionLogic
};
